import { ApolloLink, Operation, from } from '@apollo/client';

import { blockQueryingTrelloAndAtlassianLink } from './links/blockQueryingTrelloAndAtlassianLink';
import { trelloHttpLink } from './links/trelloHttpLink';
import { atlassianHttpLink } from './links/atlassianHttpLink';

function hasTrelloSelection(operation: Operation) {
  return (
    operation.query.definitions.find((definition) => {
      if (definition.kind === 'OperationDefinition') {
        return definition.selectionSet.selections.find((selection) => {
          return (
            selection.kind === 'Field' && selection.name.value === 'trello'
          );
        });
      }
    }) !== undefined
  );
}

// eslint-disable-next-line @trello/no-module-logic
export const trelloLinkChain = from([
  // We disallow querying both the Trello and Atlassian GraphQL endpoints. For now, it is unsupported to reduce complexity.
  blockQueryingTrelloAndAtlassianLink,
  // We use the existence of the "trello" field to determine if we should send this query to Trello or Atlassian. This
  // is the most efficient mechanism I could think of to accurately determine the endpoint.
  // eslint-disable-next-line @trello/no-module-logic
  ApolloLink.split(hasTrelloSelection, trelloHttpLink, atlassianHttpLink),
]);
